(function () {
  const ImagePreview = (window.ImagePreview = window.ImagePreview || {});
  var psInstance = null;
  var psReady = false;

  function isVisible(img) {
    var style = window.getComputedStyle(img);
    var displayed = style.display !== "none" && style.visibility !== "hidden";
    var hasLayout = img.offsetParent !== null;
    return displayed && hasLayout;
  }

  function checkReady() {
    if (window.PhotoSwipe && typeof window.PhotoSwipe === "function") {
      psReady = true;
      return true;
    }
    return false;
  }

  function waitReady(callback) {
    if (psReady || checkReady()) {
      callback();
      return;
    }
    var start = Date.now();
    var timer = setInterval(function () {
      if (checkReady()) {
        clearInterval(timer);
        callback();
      } else if (Date.now() - start > 6000) {
        clearInterval(timer);
        console.error("PhotoSwipe not ready");
      }
    }, 100);
  }

  function toImageArray(imagesOrSelector) {
    var nodes =
      typeof imagesOrSelector === "string"
        ? document.querySelectorAll(imagesOrSelector)
        : imagesOrSelector;
    return Array.from(nodes || []).filter(function (n) {
      return n && n.tagName && n.tagName.toLowerCase() === "img";
    });
  }

  ImagePreview.open = function (imagesOrSelector, startIndex) {
    var imgs = toImageArray(imagesOrSelector);
    if (!imgs.length) return;
    var index = Math.max(0, startIndex || 0);
    waitReady(function () {
      var items = imgs.map(function (img, i) {
        return {
          src: img.getAttribute("data-original") || img.currentSrc || img.src,
          width: img.naturalWidth || img.width || 1200,
          height: img.naturalHeight || img.height || 800,
          alt: img.alt || "Preview Image " + (i + 1),
        };
      });
      try {
        var isMobile = window.innerWidth <= 768;
        psInstance = new PhotoSwipe({
          dataSource: items,
          index: index,
          showHideAnimationType: "zoom",
          bgOpacity: 0.8,
          spacing: 0,
          allowPanToNext: true,
          loop: true,
          pinchToClose: true,
          closeOnVerticalDrag: true,
          wheelToZoom: true,
          padding: isMobile
            ? { top: 0, bottom: 0, left: 0, right: 0 }
            : { top: 20, bottom: 40, left: 60, right: 60 },
          maxZoomLevel: 3,
          arrowKeys: true,
          escKey: true,
          initialZoomLevel: "fit", // 初始缩放级别
          secondaryZoomLevel: 1.25, // 双击/按钮缩放到的级别
          zoom: true, // 明确启用缩放
          clickToCloseNonZoomable: false,
          returnFocus: false,
        });
        psInstance.init();
        psInstance.on("destroy", function () {
          psInstance = null;
        });
      } catch (e) {
        console.error("PhotoSwipe init failed:", e);
      }
    });
  };

  ImagePreview.bind = function (containerOrSelector, imagesSelector) {
    var containers =
      typeof containerOrSelector === "string"
        ? document.querySelectorAll(containerOrSelector)
        : [containerOrSelector];
    var selector = imagesSelector || "img";
    Array.from(containers || []).forEach(function (container) {
      if (!container) return;
      var imgs = Array.from(container.querySelectorAll(selector));
      imgs.forEach(function (img) {
        if (img.getAttribute("data-photoswipe-bound") === "true") return;
        img.setAttribute("data-photoswipe-bound", "true");
        img.style.cursor = "pointer";

        // 跟踪拖拽状态
        var isDragging = false;
        var startX = 0;
        var startY = 0;
        var hasMoved = false;

        var handleStart = function (e) {
          isDragging = true;
          hasMoved = false;
          startX = e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;
          startY = e.type.includes("mouse") ? e.clientY : e.touches[0].clientY;
        };

        var handleMove = function (e) {
          if (!isDragging) return;
          var currentX = e.type.includes("mouse")
            ? e.clientX
            : e.touches[0].clientX;
          var currentY = e.type.includes("mouse")
            ? e.clientY
            : e.touches[0].clientY;
          var diffX = Math.abs(currentX - startX);
          var diffY = Math.abs(currentY - startY);
          // 如果移动超过5px，认为是拖拽
          if (diffX > 5 || diffY > 5) {
            hasMoved = true;
          }
        };

        var handleEnd = function () {
          isDragging = false;
        };

        // 绑定拖拽检测事件
        img.addEventListener("mousedown", handleStart);
        img.addEventListener("touchstart", handleStart, { passive: true });
        document.addEventListener("mousemove", handleMove);
        document.addEventListener("touchmove", handleMove, { passive: true });
        document.addEventListener("mouseup", handleEnd);
        document.addEventListener("touchend", handleEnd);

        img.addEventListener("click", function (e) {
          // 如果刚刚发生了拖拽，不触发预览
          if (hasMoved) {
            hasMoved = false;
            return;
          }

          e.preventDefault();
          e.stopPropagation();
          img.style.opacity = "0.7";
          setTimeout(function () {
            img.style.opacity = "";
          }, 150);
          var currentImgs = Array.from(
            container.querySelectorAll(selector)
          ).filter(isVisible);
          var start = Math.max(0, currentImgs.indexOf(img));
          if (img.complete && (img.naturalWidth || 0) > 0) {
            ImagePreview.open(currentImgs, start);
          } else {
            img.onload = function () {
              ImagePreview.open(currentImgs, start);
            };
          }
        });
      });
    });
  };

  ImagePreview.rebind = function (containerOrSelector, imagesSelector) {
    var containers =
      typeof containerOrSelector === "string"
        ? document.querySelectorAll(containerOrSelector)
        : [containerOrSelector];
    var selector = imagesSelector || "img";
    Array.from(containers || []).forEach(function (container) {
      if (!container) return;
      var imgs = container.querySelectorAll(selector);
      Array.from(imgs).forEach(function (img) {
        img.removeAttribute("data-photoswipe-bound");
      });
    });
    ImagePreview.bind(containerOrSelector, selector);
  };

  // 初始化就绪检测
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(checkReady, 100);
    });
  } else {
    setTimeout(checkReady, 100);
  }
  window.addEventListener("load", function () {
    if (!psReady) setTimeout(checkReady, 200);
  });
})();
